import { render } from "./CloudUpload.vue?vue&type=template&id=2533f6ca"
import script from "./CloudUpload.vue?vue&type=script&lang=js"
export * from "./CloudUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/CloudUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2533f6ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2533f6ca', __exports__)) {
    api.reload('2533f6ca', __exports__)
  }
  
  module.hot.accept("./CloudUpload.vue?vue&type=template&id=2533f6ca", () => {
    api.rerender('2533f6ca', render)
  })

}


export default __exports__